export const capitalize = (s: string) => {
	if (typeof s !== 'string') return '';
	return s.charAt(0).toUpperCase() + s.slice(1);
};

/**
 * First name for greetings. A profile can come back without a name at all, and a single-word name
 * has no space to cut at, so return the whole thing rather than an empty string.
 */
export const firstName = (name?: string) => {
	if (typeof name !== 'string') return '';

	const trimmed = name.trim();
	const firstSpace = trimmed.indexOf(' ');

	return firstSpace === -1 ? trimmed : trimmed.substring(0, firstSpace);
};

export const nullIfEmptyString = (s: string | number) => {
	if (typeof s === 'number') {
		s = s.toString();
	}
	return s?.length > 0 ? s : null;
};

/**
 * Drops `suffix` from the end of `s` if it's there; anything else comes back unchanged.
 */
export const removeSuffix = (s: string | number, suffix: string) => {
	if (s === null || s === undefined) return '';
	const str = s.toString();
	return str.endsWith(suffix) ? str.slice(0, -suffix.length) : str;
};
